import { useEffect } from "react";
import { onWindowLoadFinished } from "react-builder";

export const ICanChat = () => {
    const init = () => {
        const head = document.querySelector('head');

        const jquery: HTMLScriptElement = document.createElement('script');
        jquery.src = "https://code.jquery.com/jquery-3.6.1.min.js"
        jquery.integrity = "sha256-o88AwQnZB+VDvE9tvIXrMQaPlFFSUTR+nldQm1LuPXQ="
        jquery.crossOrigin = "anonymous"
        head?.appendChild(jquery);

        jquery.onload = () => {
            const script: HTMLScriptElement = document.createElement('script');
            script.src = "https://ican4consumers.com/chat/cdn/chatlibrary.js";
            script.async = true;
            script.defer = true;
            head?.appendChild(script);

            const css: HTMLLinkElement = document.createElement('link');
            css.rel = "stylesheet";
            css.href = "https://ican4consumers.com/chat/cdn/chatlibrary.css";
            head?.appendChild(css);
        }

    }
    useEffect(() => {
        // after load
        onWindowLoadFinished().then(() => {
            init();
        })
    }, []);
    return <></>
}